module.exports = __webpack_public_path__ + "static/img/cor-zhglxt.c611313.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cor-zhglxt.png
// module id = v9i9
// module chunks = 0